module.exports = __webpack_public_path__ + "img/16.4d81ef7f.png";